import React from "react";
import { FluentProvider, teamsDarkTheme, Text } from "@fluentui/react-components";
import { CheckmarkRegular, DismissRegular, WarningRegular } from "@fluentui/react-icons";
import { msTeamsMeetingRolesEnum } from "../enum/msTeamsMeetingRolesEnum";
import { UserStatus } from "../service/InMeetingAppService";
import styles from "./duringMeeting.module.scss";
import { useTranslation } from "../../shared/translation/Translation";

export interface DuringMeetingProps {
    role: msTeamsMeetingRolesEnum;
    userStatus: UserStatus;
}

const DuringMeeting: React.FC<DuringMeetingProps> = (props) => {
    const messages = useTranslation();

    const checkValidIcon = () => {
        return <CheckmarkRegular style={{ color: "green" }} />;
    };

    const checkInvalidIcon = () => {
        return <DismissRegular style={{ color: "red" }} />;
    };

    const renderOrganizerView = () => {
        return (
            <div className={`${styles.viewContainer} ${styles.container}`}>
                <h3>{messages.duringMeeting.organizerView.header}</h3>
                <div className={styles.rulesList}>
                    <div className={styles.ruleRow}>
                        {props.userStatus.hasEnoughOneDriveSpaceToRecord ? checkValidIcon() : checkInvalidIcon()}
                        <Text>{messages.duringMeeting.organizerView.freeSpaceRequirement}</Text>
                    </div>
                    <div className={styles.ruleRow}>
                        {props.userStatus.organizerIsRecording ? checkValidIcon() : checkInvalidIcon()}
                        <Text>{messages.duringMeeting.organizerView.isRecordingRequirement}</Text>
                    </div>
                    <div className={styles.ruleRow}>
                        <WarningRegular style={{ color: "yellow" }} />
                        <Text>{messages.duringMeeting.organizerView.identityRequirement}</Text>
                    </div>
                </div>
            </div>
        );
    };

    const renderPresenterView = () => {
        return (
            <div className={`${styles.presenterContainer} ${styles.container}`}>
                <h4>{messages.duringMeeting.presenterView.header}</h4>
            </div>
        );
    };

    const renderContent = () => {
        switch (props.role) {
            case msTeamsMeetingRolesEnum.organizer:
                return renderOrganizerView();
            case msTeamsMeetingRolesEnum.presenter:
                return renderPresenterView();
            default:
                return null;
        }
    };

    return <FluentProvider theme={teamsDarkTheme}>{renderContent()}</FluentProvider>;
};

export default DuringMeeting;
